import React, { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

const WebARAppContext = createContext(null);

export const useWebARApp = () => {
  return useContext(WebARAppContext);
};

export const WebARAppProvider = ({ children, appInstance }) => {
  const [app, setApp] = useState(appInstance);
  const [canvasMap2d, setCanvasMap2d] = useState(
    appInstance?.canvasMap2d || null
  );

  useEffect(() => {
    if (!app) {
      console.error("WebARApp is not provided to WebARAppProvider.");
    }
  }, [app]);

  const showMap = (pins, onPinClicked) => {
    if (app) {
      app.showMap(pins, onPinClicked);
    } else {
      console.error("WebARApp is not initialized");
    }
  };

  const showAR = async (name = "hotei", language = "english") => {
    if (app) {
      await app.showAR(name, language);
    } else {
      console.error("WebARApp is not initialized");
    }
  };

  return (
    <WebARAppContext.Provider value={{ app, canvasMap2d, showMap, showAR }}>
      {children}
    </WebARAppContext.Provider>
  );
};

WebARAppProvider.propTypes = {
  children: PropTypes.node.isRequired, // Child elements
  appInstance: PropTypes.shape({
    canvasMap2d: PropTypes.object, // canvasMap2d object
    showMap: PropTypes.func, // showMap method
    showAR: PropTypes.func, // showAR method
  }), // WebARApp instance
};
